import {ModuleFc} from '@/project'

const module: ModuleFc<any> = (ctx) => ({
  namespaced: true,
  state: {},
  actions: {
    submitError(_, payload) {
      const {extraData = {}, captureMessage = ''} = payload
      ctx.$sentry.withScope((scope) => {
        scope.setExtra('extraData', extraData)
        ctx.$sentry.captureMessage(captureMessage)
      })
    },
  },
  mutations: {},
})

export default module
